<template>
    <div class="element-wrapper">
        <div class="row">
            <div class="col">
                <h6 class="element-header">Serviço: {{servico}}</h6>
                <div class="project-info">
                    <div class="row align-items-center">
                      <div class="col">
                        <div class="label mb-3">
                            Especialidade: 
                        </div>
                        <h4>{{especialidade.nome}}</h4>
                        <div class="label mb-3">
                            <p>{{consulta.descricaoConsulta}}</p>
                        </div>
                        <div class="row">
                          <div class="col">
                            <h6>Escolha como quer pagar:</h6>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 col-sm-12" v-if="rede.pagamentoOnline">
                            <a style="cursor: pointer" class="post-box" @click="tipoPagamento = 'Drachei'" :class="{'bg-light': tipoPagamento === 'Drachei'}">
                              <div class="post-media"><img src="@/img/brand-drachei-vert.svg" class="img-fluid" alt="Brand"></div>
                              <div class="post-content">
                                <div class="label">Dr.Achei <div class="trending down">
                                  </div>
                                </div>
                                <h5>
                                  <small class="text-muted">De: {{parseFloat(consulta.valorParticular||0.0, 10) | money({decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false})}}</small>
                                </h5>
                                <h4 class="post-title">
                                  Por: {{parseFloat(consulta.valorDrAchei||0.0, 10) | money({decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false})}}
                                </h4>
                                <div class="post-foot">
                                  
                                  <a class="post-link" href="#"><span>Selecionar</span></a>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div class="col-md-6 col-sm-12">
                            <a style="cursor: pointer" class="post-box" @click="tipoPagamento = 'SinSaude'" :class="{'bg-light': tipoPagamento === 'SinSaude'}">
                              <div class="post-media">
                                <img src="@/img/drachei-card.png" alt="Sin Saúde" class="img-fluid mt-3">
                              </div>
                              <div class="post-content">
                                <div class="label">Dr.Achei Benefícios <div v-if="consulta.porcentagemDesconto" class="trending down">
                                    <span>{{parseFloat(consulta.porcentagemDesconto, 10).toFixed(2)}}%</span><i class="os-icon os-icon-arrow-down"></i>
                                  </div></div>
                                <h5>
                                  <small class="text-muted">De: {{parseFloat(consulta.valorParticular||0.0, 10) | money({decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false})}}</small>
                                </h5>
                                <h4 class="post-title">
                                  Por: {{parseFloat(consulta.valorSinSaude||0.0, 10) | money({decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 2, masked: false})}}
                                </h4>
                                <div class="post-foot">
                                  <a class="post-link" href="#"><span>Selecionar</span></a>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <small class="text-muted">* Caso possua um Cupom de desconto utilize na próxima tela</small>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div v-if="rede.agendamento" class="row" style="margin-top: 2rem">
                  <div class="col">
                    
                      <div class="row">
                        <div class="col-md-4">
                          <h6 class="element-header">Profissional</h6>
                          <div class="label mb-3" >
                            <table class="table table-padded tabela-profissionais"><thead>
                              <tr>
                                <th>
                                Profissional
                                </th> 
                               
                              </tr></thead> 
                              <tbody>
                                <tr v-for="value in profissionais" :key="value._id">
                                  <td>
                                    <div class="custom-control custom-radio custom-control-inline">
                                      <input v-model="profissional" type="radio" class="custom-control-input" :id="`customRadio_${value._id}`" name="example" :value="value">
                                      <label class="custom-control-label" :for="`customRadio_${value._id}`"><imagem-profissional :idProfissional="value._id"></imagem-profissional> {{value.nome}}</label>
                                    </div>
                                  </td>
   
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <h6 class="element-header">Datas Disponíveis</h6>
                          <datepicker :disabledDates="disabled" @selected="selectAtendimento" :language="locale" format="DD/MM/YYYY" :inline="true"></datepicker>
                        </div>
                        <div class="col-md-4" v-if="atendimento">
                          <h6 class="element-header">Horários disponíveis</h6>
                          <a v-for="(horario, index) in atendimento.horarios" v-if="!horario.atendimento" :key="horario.horario" :class="{ 'horario-item': true, 'btn-outline-primary': true, 'btn': true, 'selected': horario === horarioSelecionado }" @click="selectHorario(index)">
                            <span class="hora-ag" v-text="horario.horario"></span>
                          </a>
                        </div>
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col">
              <button :disabled="disableBtnPagamento()" @click="finalizar()" class="btn btn-lg btn-primary text-right">Ir para Pagamento</button>
          </div>
        </div>
        <div id="modalAlertaPlano" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Aviso!</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>Para comprar com esse desconto você precisa adiquirir um plano!</p>
              <h4>Deseja adiquirir o plano?</h4>
            </div>
            <div class="modal-footer">
                  <button type="button" class="btn btn-primary" @click.stop="adquirirSinSaude">Sim</button>
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Não</button>
                </div>
              </div>
            </div>
      </div>
    </div>
</template>
<style scoped>
a.horario-item.btn-outline-secondary.btn.selected {
    border-color: #047bf8;
}
</style>
<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import ImagemProfissional from '@/components/shared/ImagemProfissional'
import eventBus from '@/event-bus'

export default {
  created () {
    moment.locale('pt-br')
    eventBus.$on('loginSuccess', this.finalizaAfterLogin)
  },
  components: {
    Datepicker,
    ImagemProfissional
  },
  data () {
    return {
      locale: ptBR,
      agenda: [],
      tipoPagamento: '',
      totalAPagar: 0,
      dataSelecionada: null,
      atendimento: null,
      horarioSelecionado: null,
      profissional: null
    }
  },
  watch: {
    tipoPagamento (newValue) {
      switch (newValue) {
        case 'Drachei':
          this.totalAPagar = this.consulta.valorDrAchei
          break
        case 'SinSaude':
          this.totalAPagar = this.consulta.valorSinSaude
          break
        default:
          this.totalAPagar = 0
      }
    },
    profissional (newValue) {
      this.selectProfissional()
    }
  },
  mounted () {
    if (!this.rede.agendamento) {
      return false
    }
    if (this.profissionalLength === 1) {
      this.profissional = this.profissionais[0]
      this.selectProfissional()
    }
  },
  methods: {
    disableBtnPagamento () {
      if (this.rede.agendamento) {
        return !this.tipoPagamento || !this.horarioSelecionado
      } else {
        return !this.tipoPagamento
      }
    },
    selectHorario (index) {
      this.horarioSelecionado = this.atendimento.horarios[index]
    },
    selectAtendimento (data) {
      this.dataSelecionada = data
      this.atendimento = this.agenda.find(agenda => agenda.dataFormatada === this.getDataFormatada(data))
    },
    selectProfissional () {
      this.$store.dispatch('findAgendaProfissional', this.profissional)
        .then(agenda => {
          this.agenda = agenda
        })
    },
    getDataFormatada (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    finalizaAfterLogin () {
      if (!this.$store.getters.user.cartao && this.tipoPagamento === 'SinSaude') {
        this.$router.push({name: 'SinSaudeCard'})
        return false
      }
      this.$store.dispatch('savePedidoFromCache')
        .then((pedido) => {
          this.$router.push({name: 'Checkout', query: {id: pedido._id}})
        })
    },
    finalizar () {
      let pedido = {
        unidade: this.rede,
        consulta: this.consulta,
        tipoPedido: this.servico,
        tipoPagamento: this.tipoPagamento,
        valorTotal: this.totalAPagar,
        desconto: this.consulta.valorParticular - this.totalAPagar
      }
      if (this.rede.agendamento) {
        pedido.profissional = this.profissionais[0]
        let agendamento = {
          agenda: this.atendimento.agenda,
          dataEscolhida: this.getDataFormatada(this.dataSelecionada),
          horarioEscolhido: this.horarioSelecionado
        }
        pedido.agendamento = agendamento
      }

      if (!this.$store.getters.user) {
        this.$store.dispatch('storePedido', pedido)
          .then(() => eventBus.$emit('openModal', 'login'))
        return false
      }

      if (!this.$store.getters.user.cartao && this.tipoPagamento === 'SinSaude') {
        window.jQuery('#modalAlertaPlano').modal('show')
        return false
      }

      pedido.cliente = this.$store.getters.user.id

      this.$store.dispatch('savePedido', pedido)
        .then(pedido => {
          // redirecionar pro checkout
          this.$router.push({name: 'Checkout', query: {id: pedido._id}})
        })
    },

    adquirirSinSaude () {
      this.$nextTick(() => {
        window.jQuery('#modalAlertaPlano').modal('hide')
        this.$router.push({name: 'SinSaudeCard'})
      })
    }
  },
  computed: {
    rede () {
      return this.$store.getters.redeSingle
    },
    consulta () {
      return this.$store.getters.consulta
    },
    servico () {
      return this.$store.getters.servico
    },
    especialidade () {
      return this.$store.getters.especialidade
    },
    profissionais () {
      return this.$store.getters.profissionais
    },
    profissionalLength () {
      return this.$store.getters.profissionais.length
    },
    disabled () {
      let dates = this.agenda.map(agenda => agenda.dataFormatada)
      return {
        customPredictor: date => {
          const d = moment(date).format('DD/MM/YYYY')
          if (dates.indexOf(d) < 0) {
            return true
          }
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/single-consultorio/ServicesTab.vue